/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Views_Scope_Product_DescInputs */

const en_views_scope_product_desc = /** @type {(inputs: Views_Scope_Product_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everyone who can open the product sees it. People with Share views can change it.`)
};

const de_views_scope_product_desc = /** @type {(inputs: Views_Scope_Product_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle mit Zugriff auf das Produkt sehen sie. Wer Ansichten teilen darf, kann sie ändern.`)
};

/**
* | output |
* | --- |
* | "Everyone who can open the product sees it. People with Share views can change it." |
*
* @param {Views_Scope_Product_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_scope_product_desc = /** @type {((inputs?: Views_Scope_Product_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_Scope_Product_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_scope_product_desc(inputs)
	return en_views_scope_product_desc(inputs)
});